import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../redux/api';
import { useQuery } from '../../../ReactQuery';
import { nuc } from '../../../utils';
import type { Project, Revision } from '../../../../shared/model-typings';

function getRevision(revisionLocator: string) {
  return get<Revision & { project: Project }>(`/api/revisions/${nuc(revisionLocator)}`, true);
}

const getQueryKey = (revisionLocator: string): QueryKey => ['revisions', revisionLocator];

/**
 * Fetch a single revision by its locator.
 *
 * @param {string} revisionLocator - The locator of the revision to fetch. No need to call nuc before passing it in here.
 * @param {boolean} shouldFetch - Allows you to delay the fetching of the revision. This can be useful if (for example) the full revision locator isn't available yet.
 */
export default function useRevision(
  revisionLocator: string,
  shouldFetch = true,
) {
  return useQuery({
    queryKey: getQueryKey(revisionLocator),
    queryFn: () => getRevision(revisionLocator),
    enabled: shouldFetch,
  });
}
